// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Wirder shared components ────────────────────────────────────
   Reusable classes derived from the approved comps. Imported
   globally from app.tsx (after tokens.css). Screen-specific layout
   lives in each screen's own .css.

   Note: production screens do NOT render a faux status bar — the OS
   provides it. Safe-area insets are handled on .screen / .appbar.
   ────────────────────────────────────────────────────────────── */

*,
*::before,
*::after {
  box-sizing: border-box;
}

/* ── Screen shell: centered mobile column ─────────────────────── */
.screen {
  min-height: 100vh;
  min-height: 100dvh;
  max-width: 420px;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  background: var(--palette-bg);
  position: relative;
  overflow: hidden;
  padding-top: env(safe-area-inset-top, 0px);
}

/* ── App bar ──────────────────────────────────────────────────── */
.appbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px var(--pad);
}
.appbar__logo {
  height: 30px;
  width: auto;
  object-fit: contain;
  transform: scaleX(-1);
}
.appbar__word {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: -0.01em;
  line-height: 1;
}
.appbar__spacer {
  flex: 1;
}
.appbar__title {
  flex: 1;
  text-align: center;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.15rem;
}

.iconbtn,
.appbar__back {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  border: 1px solid var(--palette-border);
  background: var(--palette-surface);
  color: var(--palette-text);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 40px;
  padding: 0;
}
.iconbtn svg,
.appbar__back svg {
  width: 22px;
  height: 22px;
  display: block;
}

/* ── Buttons ──────────────────────────────────────────────────── */
.btn {
  font-family: var(--font-ui);
  font-weight: 600;
  font-size: 1rem;
  border: 0;
  border-radius: var(--r-btn);
  padding: 14px 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  white-space: nowrap;
}
.btn svg {
  width: 18px;
  height: 18px;
}
.btn--primary {
  background: var(--palette-primary);
  color: var(--palette-on-primary);
}
.btn--primary:hover {
  background: var(--palette-primary-hover);
}
.btn--primary:active {
  background: var(--palette-primary-active);
}
.btn--secondary {
  background: var(--palette-secondary);
  color: var(--palette-on-secondary);
}
.btn--secondary:hover {
  background: var(--palette-secondary-hover);
}
.btn--ghost {
  background: transparent;
  color: var(--palette-text);
  border: 1.5px solid var(--palette-border-strong);
}
.btn--apple {
  background: var(--palette-text);
  color: #ffffff;
}
.btn--google {
  background: #ffffff;
  color: var(--palette-text);
  border: 1.5px solid var(--palette-border);
}
.btn--sm {
  padding: 9px 14px;
  font-size: 0.86rem;
  width: auto;
}
.btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.linkbtn {
  background: none;
  border: 0;
  color: var(--palette-secondary);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  padding: 0;
}

/* ── Cards ────────────────────────────────────────────────────── */
.card {
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  border-radius: var(--r-card);
  padding: var(--pad);
}
.card--hero {
  border: 1.5px solid var(--palette-border-strong);
  box-shadow: 6px 6px 0 0 var(--palette-surface-alt);
}

/* ── Static tile (review / how-to boards) ─────────────────────── */
.tile {
  aspect-ratio: 1;
  border-radius: var(--r-tile);
  background: var(--palette-surface);
  border: 1.5px solid var(--palette-border-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: clamp(1.1rem, 6vw, 1.6rem);
  color: var(--palette-text);
  user-select: none;
}
.tile--sel {
  background: var(--palette-secondary);
  color: #fff;
  border-color: var(--palette-secondary);
}
.tile--tail {
  background: var(--palette-primary);
  color: #fff;
  border-color: var(--palette-primary);
}
.tile--hl {
  background: var(--palette-accent-soft);
  border-color: var(--palette-primary);
  color: var(--palette-primary);
}

/* ── Chips & words ────────────────────────────────────────────── */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 999px;
  background: var(--palette-surface-alt);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--palette-text-muted);
}
.word {
  padding: 5px 11px;
  border-radius: 999px;
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  color: var(--palette-text);
  font-size: 0.84rem;
  font-weight: 600;
  text-transform: lowercase;
  font-variant: small-caps;
}
.word--gold {
  color: #8a6f10;
  background: #fbf4dd;
}
.word--miss {
  color: var(--palette-text-muted);
  background: transparent;
  border-style: dashed;
}
.word--active {
  border-color: var(--palette-primary);
  background: var(--palette-accent-soft);
  color: var(--palette-primary);
}

/* ── List row (links, settings-style) ─────────────────────────── */
.listrow {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 15px 4px;
  border: 0;
  border-top: 1px solid var(--palette-border);
  color: var(--palette-text);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.96rem;
  background: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
.listrow .lead {
  width: 20px;
  height: 20px;
  color: var(--palette-secondary);
  flex: 0 0 20px;
}
.listrow .chev {
  margin-left: auto;
  width: 18px;
  height: 18px;
  color: var(--palette-text-muted);
}

/* ── Toggle ───────────────────────────────────────────────────── */
.toggle {
  width: 46px;
  height: 28px;
  border-radius: 999px;
  background: var(--palette-border);
  position: relative;
  flex: 0 0 auto;
  cursor: pointer;
  border: 0;
}
.toggle--on {
  background: var(--palette-primary);
}
.toggle::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
}
.toggle--on::after {
  left: 21px;
}

/* Accessible focus ring for interactive elements */
.btn:focus-visible,
.iconbtn:focus-visible,
.appbar__back:focus-visible,
.listrow:focus-visible,
.linkbtn:focus-visible,
.word:focus-visible {
  outline: 2px solid var(--palette-secondary);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA;;;;;;;mEAOmE;;AAEnE;;;EAGE,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,oEAAoE;AACpE;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gDAAgD;AAClD;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,UAAU;AACZ;;AAEA,oEAAoE;AACpE;EACE,kCAAkC;EAClC,uCAAuC;EACvC,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;EAClC,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uCAAuC;EACvC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,2CAA2C;EAC3C,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,SAAS;AACX;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;;;;;;EAME,2CAA2C;EAC3C,mBAAmB;AACrB","sourcesContent":["/* ── Wirder shared components ────────────────────────────────────\n   Reusable classes derived from the approved comps. Imported\n   globally from app.tsx (after tokens.css). Screen-specific layout\n   lives in each screen's own .css.\n\n   Note: production screens do NOT render a faux status bar — the OS\n   provides it. Safe-area insets are handled on .screen / .appbar.\n   ────────────────────────────────────────────────────────────── */\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* ── Screen shell: centered mobile column ─────────────────────── */\n.screen {\n  min-height: 100vh;\n  min-height: 100dvh;\n  max-width: 420px;\n  margin-inline: auto;\n  display: flex;\n  flex-direction: column;\n  background: var(--palette-bg);\n  position: relative;\n  overflow: hidden;\n  padding-top: env(safe-area-inset-top, 0px);\n}\n\n/* ── App bar ──────────────────────────────────────────────────── */\n.appbar {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px var(--pad);\n}\n.appbar__logo {\n  height: 30px;\n  width: auto;\n  object-fit: contain;\n  transform: scaleX(-1);\n}\n.appbar__word {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.5rem;\n  letter-spacing: -0.01em;\n  line-height: 1;\n}\n.appbar__spacer {\n  flex: 1;\n}\n.appbar__title {\n  flex: 1;\n  text-align: center;\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.15rem;\n}\n\n.iconbtn,\n.appbar__back {\n  width: 40px;\n  height: 40px;\n  border-radius: 11px;\n  border: 1px solid var(--palette-border);\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex: 0 0 40px;\n  padding: 0;\n}\n.iconbtn svg,\n.appbar__back svg {\n  width: 22px;\n  height: 22px;\n  display: block;\n}\n\n/* ── Buttons ──────────────────────────────────────────────────── */\n.btn {\n  font-family: var(--font-ui);\n  font-weight: 600;\n  font-size: 1rem;\n  border: 0;\n  border-radius: var(--r-btn);\n  padding: 14px 20px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  white-space: nowrap;\n}\n.btn svg {\n  width: 18px;\n  height: 18px;\n}\n.btn--primary {\n  background: var(--palette-primary);\n  color: var(--palette-on-primary);\n}\n.btn--primary:hover {\n  background: var(--palette-primary-hover);\n}\n.btn--primary:active {\n  background: var(--palette-primary-active);\n}\n.btn--secondary {\n  background: var(--palette-secondary);\n  color: var(--palette-on-secondary);\n}\n.btn--secondary:hover {\n  background: var(--palette-secondary-hover);\n}\n.btn--ghost {\n  background: transparent;\n  color: var(--palette-text);\n  border: 1.5px solid var(--palette-border-strong);\n}\n.btn--apple {\n  background: var(--palette-text);\n  color: #ffffff;\n}\n.btn--google {\n  background: #ffffff;\n  color: var(--palette-text);\n  border: 1.5px solid var(--palette-border);\n}\n.btn--sm {\n  padding: 9px 14px;\n  font-size: 0.86rem;\n  width: auto;\n}\n.btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.linkbtn {\n  background: none;\n  border: 0;\n  color: var(--palette-secondary);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  padding: 0;\n}\n\n/* ── Cards ────────────────────────────────────────────────────── */\n.card {\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  border-radius: var(--r-card);\n  padding: var(--pad);\n}\n.card--hero {\n  border: 1.5px solid var(--palette-border-strong);\n  box-shadow: 6px 6px 0 0 var(--palette-surface-alt);\n}\n\n/* ── Static tile (review / how-to boards) ─────────────────────── */\n.tile {\n  aspect-ratio: 1;\n  border-radius: var(--r-tile);\n  background: var(--palette-surface);\n  border: 1.5px solid var(--palette-border-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: clamp(1.1rem, 6vw, 1.6rem);\n  color: var(--palette-text);\n  user-select: none;\n}\n.tile--sel {\n  background: var(--palette-secondary);\n  color: #fff;\n  border-color: var(--palette-secondary);\n}\n.tile--tail {\n  background: var(--palette-primary);\n  color: #fff;\n  border-color: var(--palette-primary);\n}\n.tile--hl {\n  background: var(--palette-accent-soft);\n  border-color: var(--palette-primary);\n  color: var(--palette-primary);\n}\n\n/* ── Chips & words ────────────────────────────────────────────── */\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 11px;\n  border-radius: 999px;\n  background: var(--palette-surface-alt);\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--palette-text-muted);\n}\n.word {\n  padding: 5px 11px;\n  border-radius: 999px;\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  color: var(--palette-text);\n  font-size: 0.84rem;\n  font-weight: 600;\n  text-transform: lowercase;\n  font-variant: small-caps;\n}\n.word--gold {\n  color: #8a6f10;\n  background: #fbf4dd;\n}\n.word--miss {\n  color: var(--palette-text-muted);\n  background: transparent;\n  border-style: dashed;\n}\n.word--active {\n  border-color: var(--palette-primary);\n  background: var(--palette-accent-soft);\n  color: var(--palette-primary);\n}\n\n/* ── List row (links, settings-style) ─────────────────────────── */\n.listrow {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  padding: 15px 4px;\n  border: 0;\n  border-top: 1px solid var(--palette-border);\n  color: var(--palette-text);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.96rem;\n  background: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n.listrow .lead {\n  width: 20px;\n  height: 20px;\n  color: var(--palette-secondary);\n  flex: 0 0 20px;\n}\n.listrow .chev {\n  margin-left: auto;\n  width: 18px;\n  height: 18px;\n  color: var(--palette-text-muted);\n}\n\n/* ── Toggle ───────────────────────────────────────────────────── */\n.toggle {\n  width: 46px;\n  height: 28px;\n  border-radius: 999px;\n  background: var(--palette-border);\n  position: relative;\n  flex: 0 0 auto;\n  cursor: pointer;\n  border: 0;\n}\n.toggle--on {\n  background: var(--palette-primary);\n}\n.toggle::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n}\n.toggle--on::after {\n  left: 21px;\n}\n\n/* Accessible focus ring for interactive elements */\n.btn:focus-visible,\n.iconbtn:focus-visible,\n.appbar__back:focus-visible,\n.listrow:focus-visible,\n.linkbtn:focus-visible,\n.word:focus-visible {\n  outline: 2px solid var(--palette-secondary);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
